import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "components/UI/Tooltip";
import { toGPXTrack, useExportGPX } from "hooks/useExportGPX";
import { useUserWaypoints } from "stores/useUserWaypoints";
import { useTranslation } from "react-i18next";
import { useRouting } from "stores/routingStore/RoutingContext";
import { CollapsibleTopMenuActionIcon } from "../CollapsibleActionIcon";

/**
 * Downloads the open waypoint, or the track in the editor as it's shown: its edited points (also a change the
 * autosave hasn't saved yet) with the name and texts of the opened track - an own, public or shared one
 */
export const ExportTrackIcon = ({ isOpen }: { isOpen: boolean }) => {
  const {
    state: { computedTrackpoints, elevations },
    openedTrack,
  } = useRouting();
  const { selectedWaypoint } = useUserWaypoints();
  const exportGPX = useExportGPX();
  const { t } = useTranslation();

  const exportToGpx = () => {
    if (selectedWaypoint) {
      exportGPX({ waypoints: [{ ...selectedWaypoint, visible: true }] });
      return;
    }
    exportGPX({
      tracks: [
        toGPXTrack(openedTrack?.track ?? { name: "Track" }, {
          trackPoints: computedTrackpoints,
          trackPointsEle: elevations,
        }),
      ],
    });
  };

  return (
    <Tooltip label={t("editmode.export_to_gpx_button_tooltip")}>
      <div>
        <CollapsibleTopMenuActionIcon
          label={t("editmode.export_to_gpx_button_tooltip")}
          isOpen={isOpen}
          disabled={computedTrackpoints.length < 2 && !selectedWaypoint}
          onClick={exportToGpx}
        >
          <FontAwesomeIcon icon={faFileExport} />
        </CollapsibleTopMenuActionIcon>
      </div>
    </Tooltip>
  );
};
